import React from "react";
import { Badge } from "@chakra-ui/react";

/**
 * Reusable Impact Tag component that displays impact level
 * based on impact score with proper color coding
 */
const ImpactTag = ({ impactScore = 0 }) => {
  // Determine impact level and styling based on score
  const getImpactConfig = (score) => {
    if (score >= 60) {
      return {
        label: "High Impact",
        bgColor: "#D1FADF",
        textColor: "#039855",
      };
    } else if (score >= 20) {
      return {
        label: "Moderate Impact",
        bgColor: "#FEF0C7",
        textColor: "#DC6803",
      };
    } else {
      return {
        label: "Needs Work",
        bgColor: "#FEE4E2",
        textColor: "#D92D20",
      };
    }
  };

  const { label, bgColor, textColor } = getImpactConfig(impactScore);

  return (
    <Badge
      bg={bgColor}
      color={textColor}
      px={2}
      py="2px"
      borderRadius="4px"
      fontSize="11px"
      fontWeight="400"
      lineHeight="1.45"
      letterSpacing="-0.01em"
      fontFamily="Geist, sans-serif"
    >
      {label}
    </Badge>
  );
};

export default ImpactTag;
